import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import moment from 'moment-timezone';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-talent-pool',
  templateUrl: './talent-pool.component.pug',
  styleUrls: ['./talent-pool.component.scss'],
  standalone: false
})
export class TalentPoolComponent implements OnInit, OnChanges {
  @Input() people: any[] = [];
  @Input() selectedPeople: any[] = [];
  @Input() selectMode = false;
  @Input() selectAllTotal = false;
  @Output() viewProfile: EventEmitter<any> = new EventEmitter();
  @Output() selectProfile: EventEmitter<any> = new EventEmitter();
  statusColorMap = {
    'Target': '#32735F',
    'Potential target': '#DE8C00',
    'No target': '#838383',
    'Unknown': 'black'
  }
  newStatusColorMap = {
    'Target': '#32735F',
    'Potential target': '#D18400',
    'No target': '#AF0000',
    'Unknown': 'black'
  }

  constructor(private permissions: PermissionsService) {
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.format_dates();
  }

  getStatusColor(status){
    return this.newStatusColorMap[status];
  }

  onViewProfile(person) {
    if (!this.selectMode) {
      this.viewProfile.emit(person.uid);
    } else {
      this.selectPerson(person);
    }
  }

  format_dates(){
    this.people.forEach(person=>{
      if (!person) return;

      if (person['opt_in_time']) {
        person['opt_in_time_formatted'] = moment(person['opt_in_time']).format('ll');
      }
      if (person['last_activity_date']){
        person['last_activity_formatted'] = moment(person['last_activity_date']).format('ll');
      }
      if (person['created']) {
        person['created_formatted'] = moment(person['last_activity_date']).format('ll');
      }
    })
  }

  selectPerson(person) {
    if (person['selected']) {
      person['selected'] = false;
      let index = this.selectedPeople.findIndex(s => s.uid === person.uid);
      if (index > -1) {
        this.selectedPeople.splice(index, 1);
      }
      this.selectProfile.emit(person.uid);
    } else {
      person['selected'] = true;
      this.selectedPeople.push(person);
    }
  }

  getLocalizedStatus(status: string): string {
    const match = ConstantsService.optedInOptions.find(option => option.value === status);
    return match ? match.label : status;
  }
}
